import { render, staticRenderFns } from "./homeMenu.vue?vue&type=template&id=c8d8c8c0&scoped=true"
import script from "./homeMenu.vue?vue&type=script&lang=js"
export * from "./homeMenu.vue?vue&type=script&lang=js"
import style0 from "./homeMenu.vue?vue&type=style&index=0&id=c8d8c8c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8c8c0",
  null
  
)

export default component.exports